import styled, { css } from "styled-components";
import { createGlobalStyle } from "styled-components";

export const SentientFont = createGlobalStyle`
  @font-face {
    font-family: 'Sentient';
    src: url(${window.gb_data.fonts.SentientRegular}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }


  @font-face {
    font-family: 'Sentient';
    src: url(${window.gb_data.fonts.SentientBold}) format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`;


export const Header = styled.div`
  color: #212529;
  text-align: center;
  font-feature-settings: "salt" on, "ss01" on;
  font-family: ${({ theme }) => theme.secondaryFont} !important;
  font-size: 23px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: -0.23px;
`;

export const Subheader = styled.div`
  color: var(--Content-Static-Default, #363d42);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const L300 = styled.div`
  color: var(--Content-Static-Strong, #111415);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.07px;
`;

export const TermsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;
`;

export const T300 = styled.div`
  color: var(--Content-Static-Default, #363D42);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const InputItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  width: 100%;
`;

export const T300Large = styled.div`
  color: var(--Content-Static-Default, #363D42);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 16px 0 32px 0;

  span {
    color: ${({ theme }) => theme.primaryColor} !important;
    cursor: pointer;
    text-decoration: 1px underline dotted;
    text-underline-offset: 2px;
  }
`;

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0 24px 0;
`;

interface InputProps {
  hasError?: boolean;
}

export const Input = styled.input<InputProps>`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: var(--Medium, 12px);
  background: var(--Background-Interactive-Default-Default, #FFF);
  /* Elevation/Main/0dp */
  box-shadow: 0 0.5px 0.25px 0 var(--neutral-darken-200-d, rgba(12, 34, 45, 0.09)), 0 0 16px 0 var(--neutral-darken-100-d, rgba(22, 22, 55, 0.03)), 0 0 1px 0 var(--neutral-darken-400-d, rgba(10, 27, 41, 0.29)) inset;  
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border: none; 

  &:focus,
  &:focus-visible,
  &:active {
    border: 2px solid ${({ theme }) => theme.primaryColor} !important;
    outline: none;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border: 2px solid #FFC2CB;
    `}
`;

export const InputErrorText = styled.div`
  color: var(--Content-Static-Negative, #BD0026);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.06px;
  display: flex;
  gap: 4px;
  align-items: center;
`;


export const PrimaryButton = styled.button`
  display: flex;
  width: 100%;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: none;
  border-radius: var(--Rounded, 999px);
  background: ${({ theme }) => theme.primaryColor} !important;
  text-align: center;
  color: var(--Content-On-Interactive-On-Accent, #FFF);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.16px;
`;


export const T100 = styled.div`
  color: var(--Content-Static-Default, #363D42);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.06px;
  display: inline;

  span {
    font-weight: 700;
    color: ${({ theme }) => theme.primaryColor} !important;
  }
`;